
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_0:1800)"}},[_c('path',{attrs:{"d":"M7.727 8.022H8.86V2.379H6.561v.935h1.166v4.708zm4.847.099c1.485 0 2.497-.88 2.497-2.123 0-.913-.56-1.53-1.386-1.793.495-.231.87-.66.87-1.31 0-.868-.749-1.671-1.98-1.671-1.21 0-1.98.803-1.98 1.672 0 .649.373 1.078.868 1.309-.814.264-1.397.88-1.397 1.793 0 1.243 1.045 2.123 2.508 2.123zm0-4.334c-.517 0-.88-.33-.88-.814 0-.495.374-.825.88-.825s.88.33.88.825c0 .484-.363.814-.88.814zm0 3.333c-.814 0-1.33-.495-1.33-1.2 0-.714.516-1.242 1.33-1.242.814 0 1.331.528 1.331 1.243 0 .704-.517 1.199-1.33 1.199zm6.295 1c1.584 0 2.992-1.231 2.992-2.925 0-1.705-1.408-2.904-2.992-2.904-1.562 0-2.97 1.199-2.97 2.904 0 1.694 1.408 2.926 2.97 2.926zm0-1c-1 0-1.793-.781-1.793-1.925 0-1.155.792-1.914 1.793-1.914 1.023 0 1.815.759 1.815 1.914 0 1.144-.792 1.925-1.815 1.925zm5.975-.737c1.177 0 2.123-.87 2.123-2.046 0-1.166-.946-2.046-2.123-2.046-1.177 0-2.123.88-2.123 2.046 0 1.177.946 2.046 2.123 2.046zm0-.858c-.649 0-1.056-.484-1.056-1.188 0-.693.407-1.177 1.056-1.177.65 0 1.078.484 1.078 1.177 0 .704-.429 1.188-1.078 1.188z","fill":"#000"}}),_c('path',{attrs:{"opacity":".2","d":"M3.434 7.272C1.538 8.36.422 9.694.422 11.136c0 3.66 7.198 6.628 16.078 6.628 8.88 0 16.078-2.968 16.078-6.628 0-1.675-1.508-3.205-3.994-4.372","stroke":"#000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_0:1800"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.422 .022)","d":"M0 0h32.156v17.742H0z"}})])])])
          )
        }
      }
    